/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import InputBox from '../../components/InputBox'
import ErrorMessage from '../../components/ErrorMessage'
import TextArea from '../../components/TextArea'
import Dropdown from '../../components/Dropdown'
import TopHeader from '../../components/TopHeader'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import moment from 'moment'
import Loader from '../../components/Loader'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../components/SearchEmptyScreen'
import InputTimer from '../../components/InputTimer'
import { useAddMonitorTemplatesMutation, useGetMonitorViewTemplatesQuery, useEditMonitorTemplatesMutation,useLazyGetMonitorViewTemplatesQuery } from '../../features/monitorConditionTemplate'
import AddManageMoitoringCondTemplate from './addTemplate'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'

export default function AddManageMonitoringCondTemplateIndex({ edit }) {
    const [addMonitorTemplate] = useAddMonitorTemplatesMutation()
    const location = useLocation()
    const isFromEdit = location.state?.[1] || false; 
    const [editTemplate] = useEditMonitorTemplatesMutation()
    const unittype = useSelector(state => state.systemConfigData.vitalInfo.blood_glucose)
    const unittype1 = useSelector(state => state.systemConfigData.vitalInfo.blood_pressure)
    const unittype2 = useSelector(state => state.systemConfigData.vitalInfo.temperature)
    const unittype3 = useSelector(state => state.systemConfigData.vitalInfo.SP02)
    const unittype4 = useSelector(state => state.systemConfigData.vitalInfo.pulse)
    const unittype5 = useSelector(state => state.systemConfigData.vitalInfo.weight)
    const [templateName, setTemplateName] = useState('');
    const [nextTarget, setNextTarget] = useState('');
    const [bloodGlucose, setBloodGlucose] = useState({
        startTimeMoniHourBG: '',
        startTimeMoniMinuteBG: '',
        frequency: '',
        time_period: 'Day(s)',
        maximumTimeDelayHourBG: '',
        maximumTimeDelayMinuteBG: '',
        lower_Threshold: '',
        upper_Threshold: '',
        isAMorPM: 'AM',
        unit:'',
    });
    const [bloodPressure, setBloodPressure] = useState({
        startTimeMoniHourBP: '',
        startTimeMoniMinuteBP: '',
        frequencyBP: '',
        time_periodBP: 'Day(s)',
        maximumTimeDelayHourBP: '',
        maximumTimeDelayMinuteBP: '',
        lower_Threshold_systolicBP: '',
        upper_Threshold_systolicBP: '',
        lower_Threshold_DiastolicBP: '',
        upper_Threshold_DiastolicBP: '',
        isAMorPMBP: 'AM',
        unit:'',

    });
    const [spo2, setSpo2] = useState({
        startTimeMoniHourSPO2: '',
        startTimeMoniMinuteSPO2: '',
        frequencySPO2: '',
        time_periodSPO2: 'Day(s)',
        maximumTimeDelayHourSPO2: '',
        maximumTimeDelayMinuteSPO2: '',
        lower_ThresholdSPO2: '',
        isAMorPMSPO2: 'AM',
        unit:'',

    });
    const [pulse, setPulse] = useState({
        startTimeMoniHourPulse: '',
        startTimeMoniMinutePulse: '',
        frequencyPulse: '',
        time_periodPulse: 'Day(s)',
        maximumTimeDelayHourPulse: '',
        maximumTimeDelayMinutePulse: '',
        lower_ThresholdPulse: '',
        upper_ThresholdPulse: '',
        isAMorPMPulse: 'AM',
        unit:'',
    });
    const [temprature, setTemprature] = useState({
        startTimeMoniHourTemp: '',
        startTimeMoniMinuteTemp: '',
        frequencyTemp: '',
        time_periodTemp: 'Day(s)',
        maximumTimeDelayHourTemp: '',
        maximumTimeDelayMinuteTemp: '',
        upper_ThresholdTemp: '',
        isAMorPMTemp: 'AM',
        unit:'',
    });
    const [weight, setWeight] = useState({
        startTimeMoniHourWeight: '',
        startTimeMoniMinuteWeight: '',
        frequencyWeight: '',
        time_periodWeight: 'Day(s)',
        maximumTimeDelayHourWeight: '',
        maximumTimeDelayMinuteWeight: '',
        lower_ThresholdWeight: '',
        upper_ThresholdWeight: '',
        isAMorPMWeight: 'AM',
        unit:'',
    });

    const { id } = useParams()
    const [skip, setSkip] = useState(true)
    const [isDisableCanel, setIsDisableCancel] = useState(true)
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const { setToastmessage, setToastErrorMessage, isSideBar,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing } = useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const [emptyArea, setEmptyArea] = useState(false);
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [usernameError, setUsernameError] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const dispatch = useDispatch()
    const [isBGCheckboxChecked, setBGCheckboxChecked] = useState(false);
    const [isBPCheckboxChecked, setBPCheckboxChecked] = useState(false);
    const [isSPO2CheckboxChecked, setSPO2CheckboxChecked] = useState(false);
    const [isPulseCheckboxChecked, setPulseCheckboxChecked] = useState(false);
    const [isTempCheckboxChecked, setTempCheckboxChecked] = useState(false);
    const [isWeightCheckboxChecked, setWeightCheckboxChecked] = useState(false);
    const { data, isFetching, status } = useGetMonitorViewTemplatesQuery(id, { skip: skip })
    const [submitSelected,setSubmitSelected]=useState(false);
    const [trigger,result] = useLazyGetMonitorViewTemplatesQuery()
    const [dataloading,setDataLoading] = useState(true)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    

    useEffect(() => {
        if (edit) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-edit-monitoring-template');
            } else {
                setQueryParamsadmin('type=admin-edit-monitoring-conditions');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-add-monitoring-template');
            } else {
                setQueryParamsadmin('type=admin-add-monitoring-conditions');
            }
        }
    }, [userType,edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    
    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(() => {
        if (edit) {
            setSkip(false)
            if(result!==undefined&&result?.data?.template_name!==undefined){
                dispatch(handleTargetUserEditId(result?.data?.template_name))
                if(edit&&!messageSent&&editSocket){
                   
                    sendMessageToStartEditing(result?.data?.template_name)
                
                    let message
                    editSocket.onmessage = (event) =>{
                        message = event.data
                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                            setDataLoading(false)
                        } else{
                            dispatch(handleEditMessageSent(false))
                            navigate('/manage-monitoring-condition-templates')
                            { (JSON.parse(message)?.adminId) &&
                                setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this monitoring condition template`)
                            }
                        }
                    }    
                }else{
                    setDataLoading(false)
                }
                setTemplateName(data?.template_name)
                setBGCheckboxChecked(data?.blood_glucose ? true : false);
                data?.blood_glucose ? setBloodGlucose({
                    startTimeMoniHourBG: data?.blood_glucose?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinuteBG: data?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequency: data?.blood_glucose?.frequency_of_monitoring,
                    time_period: data?.blood_glucose?.time_period,
                    maximumTimeDelayHourBG: data?.blood_glucose?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinuteBG: data?.blood_glucose?.maximum_time_delay?.split(':')[1],
                    lower_Threshold: data?.blood_glucose?.lower_threshold?.toString(),
                    upper_Threshold: data?.blood_glucose?.upper_threshold?.toString(),
                    isAMorPM: data?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    unit:data?.blood_glucose?.unit
                }) : ''

                setBPCheckboxChecked(data?.blood_pressure ? true : false);

                data?.blood_pressure ? setBloodPressure({
                    startTimeMoniHourBP: data?.blood_pressure?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinuteBP: data?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequencyBP: data?.blood_pressure?.frequency_of_monitoring,
                    time_periodBP: data?.blood_pressure?.time_period,
                    maximumTimeDelayHourBP: data?.blood_pressure?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinuteBP: data?.blood_pressure?.maximum_time_delay?.split(':')[1],
                    lower_Threshold_systolicBP: data?.blood_pressure?.lower_threshold_systolic?.toString(),
                    upper_Threshold_systolicBP: data?.blood_pressure?.upper_threshold_systolic?.toString(),
                    isAMorPMBP: data?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    lower_Threshold_DiastolicBP: data?.blood_pressure?.lower_threshold_diastolic?.toString(),
                    upper_Threshold_DiastolicBP: data?.blood_pressure?.upper_threshold_diastolic?.toString(),
                    unit:data?.blood_pressure?.unit

                }) : ''
                setSPO2CheckboxChecked(data?.spo2 ? true : false);

                data?.spo2 ? setSpo2({
                    startTimeMoniHourSPO2: data?.spo2?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinuteSPO2: data?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequencySPO2: data?.spo2?.frequency_of_monitoring,
                    time_periodSPO2: data?.spo2?.time_period,
                    maximumTimeDelayHourSPO2: data?.spo2?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinuteSPO2: data?.spo2?.maximum_time_delay?.split(':')[1],
                    lower_ThresholdSPO2: data?.spo2?.lower_threshold?.toString(),
                    isAMorPMSPO2: data?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    unit:data?.spo2?.unit
                }) : ''
                setPulseCheckboxChecked(data?.pulse ? true : false);

                data?.pulse ? setPulse({
                    startTimeMoniHourPulse: data?.pulse?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinutePulse: data?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequencyPulse: data?.pulse?.frequency_of_monitoring,
                    time_periodPulse: data?.pulse?.time_period,
                    maximumTimeDelayHourPulse: data?.pulse?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinutePulse: data?.pulse?.maximum_time_delay?.split(':')[1],
                    lower_ThresholdPulse: data?.pulse?.lower_threshold?.toString(),
                    upper_ThresholdPulse: data?.pulse?.upper_threshold?.toString(),
                    isAMorPMPulse: data?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    unit:data?.pulse?.unit

                }) : ''
                setTempCheckboxChecked(data?.temperature ? true : false);

                data?.temperature ? setTemprature({
                    startTimeMoniHourTemp: data?.temperature?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinuteTemp: data?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequencyTemp: data?.temperature?.frequency_of_monitoring,
                    time_periodTemp: data?.temperature?.time_period,
                    maximumTimeDelayHourTemp: data?.temperature?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinuteTemp: data?.temperature?.maximum_time_delay?.split(':')[1],
                    upper_ThresholdTemp: data?.temperature?.upper_threshold?.toString(),
                    isAMorPMTemp: data?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    unit:data?.temperature?.unit

                }) : ''
                setWeightCheckboxChecked(data?.weight ? true : false);

                data?.weight ? setWeight({
                    startTimeMoniHourWeight: data?.weight?.start_time_of_monitoring?.split(':')[0],
                    startTimeMoniMinuteWeight: data?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                    frequencyWeight: data?.weight?.frequency_of_monitoring,
                    time_periodWeight: data?.weight?.time_period,
                    maximumTimeDelayHourWeight: data?.weight?.maximum_time_delay?.split(':')[0],
                    maximumTimeDelayMinuteWeight: data?.weight?.maximum_time_delay?.split(':')[1],
                    lower_ThresholdWeight: data?.weight?.lower_threshold?.toString(),
                    upper_ThresholdWeight: data?.weight?.upper_threshold?.toString(),
                    isAMorPMWeight: data?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                    unit:data?.weight?.unit
                }) : ''


                setSkip(true)
            }
            return(()=>{
          
                if(((location.state===null || location.state==='')&&result?.data?.template_name!==undefined)){
                    
                    sendMessageToStopEditing(result?.data?.template_name)
                }  
            })
        }
    }, [edit, result])

    function handleTemplateNameChange(id, value) {
        setUsernameError(false)
        setIsDisableCancel(false)
        setTemplateName(value);

    };

    useEffect(()=>{
        if(id){
            trigger(id)      
        }       
    },[id])

    useEffect(()=>{
        return(()=>{
       
            if(location?.state!==null||location?.state!==''){
         
                sendMessageToStopEditing()
            }
        })
       
    },[])
    // for blood glucose


    const handleMonitoringConditiontemplate = async () => {
        setSubmitSelected(true)

        const hasEmptyFields = () => {
            let isFieldsEmpty = false;

            // Check if templateName is empty
            if (templateName?.trim() === "") {
                isFieldsEmpty = true;
            }

            // Check if BG checkbox is checked and its fields are empty
            if (isBGCheckboxChecked) {
                Object?.values(bloodGlucose).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }
            // Check if BP checkbox is checked and its fields are empty
            if (isBPCheckboxChecked && !isFieldsEmpty) {
                Object.values(bloodPressure).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }

            // Check if SPO2 checkbox is checked and its fields are empty
            if (isSPO2CheckboxChecked) {
                Object.values(spo2).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }
            // Check if Pulse checkbox is checked and its fields are empty
            if (isPulseCheckboxChecked) {
                Object.values(pulse).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }
            // Check if Temprature checkbox is checked and its fields are empty
            if (isTempCheckboxChecked) {
                Object.values(temprature).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }
            // Check if Temprature checkbox is checked and its fields are empty
            if (isWeightCheckboxChecked) {
                Object.values(weight).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        return;
                    }
                });
            }

            return isFieldsEmpty;
        };
        if (hasEmptyFields()) {
            setLoading(false);
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        } 
        if (
            (parseInt(bloodGlucose.lower_Threshold) > parseInt(bloodGlucose.upper_Threshold)) ||
            (parseInt(bloodPressure.lower_Threshold_DiastolicBP) > parseInt(bloodPressure.upper_Threshold_DiastolicBP)) ||
            (parseInt(bloodPressure.lower_Threshold_systolicBP) > parseInt(bloodPressure.upper_Threshold_systolicBP)) ||
            (parseInt(pulse.lower_ThresholdPulse) > parseInt(pulse.upper_ThresholdPulse)) ||
            (parseInt(weight.lower_ThresholdWeight) > parseInt(weight.upper_ThresholdWeight))
        ){
            setToastErrorMessage("Lower Threshold cannot be greater than Upper Threshold");  
            return ;
        }
        else {
            setConfirmationState(true);
        }
    };



    const handleFinalSubmit = async () => {
        try {
            setLoading(true);

            let combinedStartTimeBG = `${bloodGlucose?.startTimeMoniHourBG?.padStart(2, '0')}:${bloodGlucose?.startTimeMoniMinuteBG?.padEnd(2, '0')} ${bloodGlucose?.isAMorPM}`;
            let maximumTimeDelayBG = `${bloodGlucose?.maximumTimeDelayHourBG?.padStart(2, '0')}:${bloodGlucose?.maximumTimeDelayMinuteBG?.padEnd(2, '0')}`;

            let combinedStartTimeBP = `${bloodPressure?.startTimeMoniHourBP?.padStart(2, '0')}:${bloodPressure?.startTimeMoniMinuteBP?.padEnd(2, '0')} ${bloodPressure?.isAMorPMBP}`;
            let maximumTimeDelayBP = `${bloodPressure?.maximumTimeDelayHourBP?.padStart(2, '0')}:${bloodPressure?.maximumTimeDelayMinuteBP?.padEnd(2, '0')}`;

            let combinedStartTimeSpo2 = `${spo2?.startTimeMoniHourSPO2?.padStart(2, '0')}:${spo2?.startTimeMoniMinuteSPO2?.padEnd(2, '0')} ${spo2?.isAMorPMSPO2}`;
            let maximumTimeDelaySpo2 = `${spo2?.maximumTimeDelayHourSPO2?.padStart(2, '0')}:${spo2?.maximumTimeDelayMinuteSPO2?.padEnd(2, '0')}`;

            let combinedStartTimePulse = `${pulse?.startTimeMoniHourPulse?.padStart(2, '0')}:${pulse?.startTimeMoniMinutePulse?.padEnd(2, '0')} ${pulse?.isAMorPMPulse}`;
            let maximumTimeDelayPulse = `${pulse?.maximumTimeDelayHourPulse?.padStart(2, '0')}:${pulse?.maximumTimeDelayMinutePulse?.padEnd(2, '0')}`;

            let combinedStartTimeTemprature = `${temprature?.startTimeMoniHourTemp?.padStart(2, '0')}:${temprature?.startTimeMoniMinuteTemp?.padEnd(2, '0')} ${temprature?.isAMorPMTemp}`;
            let maximumTimeDelayTemprature = `${temprature?.maximumTimeDelayHourTemp?.padStart(2, '0')}:${temprature?.maximumTimeDelayMinuteTemp?.padEnd(2, '0')}`;

            let combinedStartTimeWeight = `${weight?.startTimeMoniHourWeight?.padStart(2, '0')}:${weight?.startTimeMoniMinuteWeight?.padEnd(2, '0')} ${weight?.isAMorPMWeight}`;
            let maximumTimeDelayWeight = `${weight?.maximumTimeDelayHourWeight?.padStart(2, '0')}:${weight?.maximumTimeDelayMinuteWeight?.padEnd(2, '0')}`;

            let body = {
                "template_name": templateName?.trim(),
            };

            if (isBGCheckboxChecked) {
                body["blood_glucose"] = {
                    "frequency_of_monitoring": bloodGlucose?.frequency,
                    "time_period": bloodGlucose?.time_period,
                    "start_time_of_monitoring": combinedStartTimeBG,
                    "maximum_time_delay": maximumTimeDelayBG,
                    "upper_threshold": bloodGlucose?.upper_Threshold,
                    "lower_threshold": bloodGlucose?.lower_Threshold,
                    "unit": (edit && bloodGlucose?.unit) ? bloodGlucose?.unit : unittype    
                };
            }

            if (isBPCheckboxChecked) {
                body["blood_pressure"] = {
                    "frequency_of_monitoring": bloodPressure?.frequencyBP,
                    "time_period": bloodPressure?.time_periodBP,
                    "start_time_of_monitoring": combinedStartTimeBP,
                    "maximum_time_delay": maximumTimeDelayBP,
                    "upper_threshold_systolic": bloodPressure?.upper_Threshold_systolicBP,
                    "lower_threshold_systolic": bloodPressure?.lower_Threshold_systolicBP,
                    "upper_threshold_diastolic": bloodPressure?.upper_Threshold_DiastolicBP,
                    "lower_threshold_diastolic": bloodPressure?.lower_Threshold_DiastolicBP,
                    "unit": (edit && bloodPressure?.unit) ? bloodPressure?.unit : unittype1,
                };
            }

            if (isSPO2CheckboxChecked) {
                body["spo2"] = {
                    "frequency_of_monitoring": spo2?.frequencySPO2,
                    "time_period": spo2?.time_periodSPO2,
                    "start_time_of_monitoring": combinedStartTimeSpo2,
                    "maximum_time_delay": maximumTimeDelaySpo2,
                    "lower_threshold": spo2?.lower_ThresholdSPO2,
                    "unit": (edit && spo2?.unit) ? spo2?.unit : unittype3,
                };
            }

            if (isPulseCheckboxChecked) {
                body["pulse"] = {
                    "frequency_of_monitoring": pulse?.frequencyPulse,
                    "time_period": pulse?.time_periodPulse,
                    "start_time_of_monitoring": combinedStartTimePulse,
                    "maximum_time_delay": maximumTimeDelayPulse,
                    "upper_threshold": pulse?.upper_ThresholdPulse,
                    "lower_threshold": pulse?.lower_ThresholdPulse,
                    "unit":(edit && pulse?.unit) ? pulse?.unit : unittype4,
                };
            }

            if (isTempCheckboxChecked) {
                body["temperature"] = {
                    "frequency_of_monitoring": temprature?.frequencyTemp,
                    "time_period": temprature?.time_periodTemp,
                    "start_time_of_monitoring": combinedStartTimeTemprature,
                    "maximum_time_delay": maximumTimeDelayTemprature,
                    "upper_threshold": temprature?.upper_ThresholdTemp,
                    "unit":(edit && temprature?.unit) ? temprature?.unit :unittype2,
                };
            }

            if (isWeightCheckboxChecked) {
                body["weight"] = {
                    "frequency_of_monitoring": weight?.frequencyWeight,
                    "time_period": weight?.time_periodWeight,
                    "start_time_of_monitoring": combinedStartTimeWeight,
                    "maximum_time_delay": maximumTimeDelayWeight,
                    "upper_threshold": weight?.upper_ThresholdWeight,
                    "lower_threshold": weight?.lower_ThresholdWeight,
                    "unit":(edit && weight?.unit) ? weight?.unit :unittype5,
                };
            }
            if (edit) {
                const editRes = await editTemplate({ id, body })
                if (editRes?.error?.data?.message) {
                    if (editRes?.error?.data?.message === "Monitoring template already exists. Please try another") {
                        setUsernameError(true);
                        setConfirmationState(false)
                    }
                    setConfirmationState(false)
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else {

                    setConfirmationState(false)
                    navigate(`/manage-monitoring-condition-templates/${id}`, { state: edit ? location.state : '' })
                    setToastmessage(`Monitoring conditions template updated successfully`);
                    setLoading(false)


                }


            }
            else {
                const addRes = await addMonitorTemplate(body);
                if (addRes?.error?.data?.message) {
                    setConfirmationState(false);
                    setToastErrorMessage(addRes?.error?.data?.message);
                    setLoading(false);
                    if (addRes?.error?.data?.message === "Monitoring template already exists. Please try another") {
                        setUsernameError(true);
                        setConfirmationState(false)
                    }
                } else {
                    navigate(`/manage-monitoring-condition-templates/${addRes?.data?.template_id}`);
                    setConfirmationState(false)
                    setToastmessage(addRes?.data?.message);

                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
            setToastErrorMessage(error.message);
        }
    };


    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    // Function to reset all state values to empty
    const resetForm = () => {
        setTemplateName('');
        setBloodGlucose({
            startTimeMoniHourBG: '',
            startTimeMoniMinuteBG: '',
            frequency: '',
            time_period: '',
            maximumTimeDelayHourBG: '',
            maximumTimeDelayMinuteBG: '',
            lower_Threshold: '',
            upper_Threshold: '',
        });
        setBloodPressure({
            startTimeMoniHourBP: '',
            startTimeMoniMinuteBP: '',
            frequencyBP: '',
            time_periodBP: '',
            maximumTimeDelayHourBP: '',
            maximumTimeDelayMinuteBP: '',
            lower_Threshold_systolicBP: '',
            upper_Threshold_systolicBP: '',
            lower_Threshold_DiastolicBP: '',
            upper_Threshold_DiastolicBP: '',
        });
        setSpo2({
            startTimeMoniHourSPO2: '',
            startTimeMoniMinuteSPO2: '',
            frequencySPO2: '',
            time_periodSPO2: '',
            maximumTimeDelayHourSPO2: '',
            maximumTimeDelayMinuteSPO2: '',
            lower_ThresholdSPO2: '',
        });
        setPulse({
            startTimeMoniHourPulse: '',
            startTimeMoniMinutePulse: '',
            frequencyPulse: '',
            time_periodPulse: '',
            maximumTimeDelayHourPulse: '',
            maximumTimeDelayMinutePulse: '',
            lower_ThresholdPulse: '',
            upper_ThresholdPulse: '',
        });
        setTemprature({
            startTimeMoniHourTemp: '',
            startTimeMoniMinuteTemp: '',
            frequencyTemp: '',
            time_periodTemp: '',
            maximumTimeDelayHourTemp: '',
            maximumTimeDelayMinuteTemp: '',
            upper_ThresholdTemp: '',
        });
        setWeight({
            startTimeMoniHourWeight: '',
            startTimeMoniMinuteWeight: '',
            frequencyWeight: '',
            time_periodWeight: '',
            maximumTimeDelayHourWeight: '',
            maximumTimeDelayMinuteWeight: '',
            lower_ThresholdWeight: '',
            upper_ThresholdWeight: '',
        });
    };

  

    // Cancel button click handler
    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Reset form values to empty
        resetForm();
        if (nextTarget === 'view') {
            navigate(`/manage-monitoring-condition-templates/${id}`);
        } else {
            navigate('/manage-monitoring-condition-templates');
        }
        // navigate('/manage-monitoring-condition-templates'); // Replace with your actual route
    };

    const handleCancelBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        const templateNameFilled = templateName?.trim() !== '';
        const bloodGlucoseFilled = Object.values(bloodGlucose).some((value) => typeof value !== 'boolean' && value?.trim() !== '');
        const bloodPressureFilled = Object.values(bloodPressure).some((value) => typeof value !== 'boolean' && value?.trim() !== '');
        const spo2Filled = Object.values(spo2).some((value) => typeof value !== 'boolean' && value?.trim() !== '');
        const pulseFilled = Object.values(pulse).some((value) => typeof value !== 'boolean' && value?.trim() !== '');
        const tempratureFilled = Object.values(temprature).some((value) => typeof value !== 'boolean' && value?.trim() !== '');
        const weightFilled = Object.values(weight).some((value) => typeof value !== 'boolean' && value?.trim() !== '');

        const isAnyValueFilled =
            templateNameFilled ||
            bloodGlucoseFilled ||
            bloodPressureFilled ||
            spo2Filled ||
            pulseFilled ||
            tempratureFilled ||
            weightFilled;
        // if (isDisableCanel) {
        //     navigate('/manage-monitoring-condition-templates');
        // }
        // if (isAnyValueFilled) {
        //     setConfirmationStateCancel(true);
        // } else {
        //     setConfirmationStateCancel(false);
        //     // navigate('/manage-organizations/manage-organization-users/add-organization-user');
        // }
        if (isDisableCanel && (isFromEdit===true)) {
            navigate(`/manage-monitoring-condition-templates/${id}`);
        } else if (isDisableCanel) {
            navigate('/manage-monitoring-condition-templates',{state:stateToPass});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }   
    };
    

    return (
        <>

            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-hidden'>
                <TopHeader title={"Manage Monitoring Conditions Templates"} />
                {((isFetching && status !== "fulfilled") || loadingStatus) ? <CustomOverLay Active text="Loading Monitoring Conditions Template..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 pl-6 pr-[10px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-monitoring-condition-templates" state={Array.isArray(location.state) ? '' : location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Monitoring Conditions Template </h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-monitoring-condition-templates/${location.state?.[2]}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Monitoring Conditions Template</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{edit ? 'Edit Monitoring Conditions' : 'Create Monitoring Conditions Template'}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    <div className='flex items-center'>
                                        {isFromEdit===true ?
                                            <Link to={`/manage-monitoring-condition-templates/${location?.state?.[2]}`}className='items-center min-w-max flex z-[20]'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] pl-3'>View Monitoring Conditions Template</span>
                                            </Link> 
                                            :    
                                            <div onClick={handleCancelBottom} state={Array.isArray(location.state) ? '' : location.state} className='flex cursor-pointer items-center min-w-fit'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] ml-3 z-[99]'>Go back to Listing</span>
                                            </div>
                                        }
                                        <h1 className='text-xl font-normal text-[#000000] w-full text-center 2xl:-ml-[262px] xl:-ml-[80px] ml-[-10px]'>
                                            {edit ? 'Edit Monitoring Conditions Template' : 'Create Monitoring Conditions Template'}
                                        </h1>
                                    </div>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5  overflow-auto  bg-white`}>
                                    <div className="border border-[#C5C9DA] rounded-lg py-4 mb-3 ">
                                        <div className='px-6 2xl:px-[58px]'>
                                            <div className='flex flex-wrap -mx-3'>
                                                <div className='xl:w-1/3 xl:min-w-[33.33%] min-w-[300px] max-w-[220px] px-3 mb-[22px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Template Name*"}
                                                            placeholder={"Enter template name"}
                                                            id={"template_name"}
                                                            datatestid={"template_name"}
                                                            htmlFor={"template_name"}
                                                            value={templateName}
                                                            data_testid={"template_name"}
                                                            maxLength={30}
                                                            emailError={usernameError}
                                                            emptyField={emptyField && templateName?.trim() === ""}
                                                            handleOnChangeInput={handleTemplateNameChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='pl-6 2xl:pl-[58px] pr-3 2xl:pr-[29px]'>
                                            <AddManageMoitoringCondTemplate
                                                edit={edit}
                                                setTemplateName={setTemplateName}
                                                bloodGlucose={bloodGlucose}
                                                setBloodGlucose={setBloodGlucose}
                                                bloodPressure={bloodPressure}
                                                setBloodPressure={setBloodPressure}
                                                spo2={spo2}
                                                setSpo2={setSpo2}
                                                pulse={pulse}
                                                setPulse={setPulse}
                                                temprature={temprature}
                                                setTemprature={setTemprature}
                                                weight={weight}
                                                setWeight={setWeight}
                                                isBGCheckboxChecked={isBGCheckboxChecked}
                                                setBGCheckboxChecked={setBGCheckboxChecked}
                                                isBPCheckboxChecked={isBPCheckboxChecked}
                                                setBPCheckboxChecked={setBPCheckboxChecked}
                                                isSPO2CheckboxChecked={isSPO2CheckboxChecked}
                                                setSPO2CheckboxChecked={setSPO2CheckboxChecked}
                                                isPulseCheckboxChecked={isPulseCheckboxChecked}
                                                setPulseCheckboxChecked={setPulseCheckboxChecked}
                                                isTempCheckboxChecked={isTempCheckboxChecked}
                                                setTempCheckboxChecked={setTempCheckboxChecked}
                                                isWeightCheckboxChecked={isWeightCheckboxChecked}
                                                setWeightCheckboxChecked={setWeightCheckboxChecked}
                                                unittype={unittype}
                                                unittype1={unittype1}
                                                unittype2={unittype2}
                                                unittype3={unittype3}
                                                unittype4={unittype4}
                                                unittype5={unittype5}
                                                emptyField={emptyField}
                                                setEmptyField={setEmptyField}
                                                data={data}
                                                isDisableCanel={isDisableCanel}
                                                setIsDisableCancel={setIsDisableCancel}
                                                submitSelected={submitSelected}
                                                setSubmitSelected={setSubmitSelected}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className='flex justify-end pr-5'>
                                    <button
                                        type="button"
                                        id="cancel"
                                        onClick={() => handleCancelBottom()}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
                                        border border-[#972E4C] disabled:opacity-50 disabled:cursor-not-allowed`}
                                    // disabled={isDisableCanel}
                                    >
                                        Cancel
                                    </button>
                                    <button type='button'
                                        id="update"
                                        data-testid="submit"
                                        onClick={handleMonitoringConditiontemplate}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        {edit ? 'Update' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                data_testid="add_admin"
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle={`${edit ? 'Update' : 'Create'} Template`}
                                message={`Are you sure you want to ${edit ? 'update' : 'create'} this monitoring conditions template?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}

                                message={`Are you sure you want to cancel the changes?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )
}
